/**
 * Created by Jerker Nord on 2020-08-21.
 */
import {ReelStopPresentationController} from "@nolimitcity/slot-game/bin/core/reelstoppresentation/ReelStopPresentationController";
import {MonkeysGoldGameModuleConfig} from "../../MonkeysGoldGameModuleConfig";
import {MonkeysGoldBigSymbolLandView} from "./MonkeysGoldBigSymbolLandView";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {MGReelEvents} from "../../reel/MGReelPartAnimator";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {MonkeysGoldParsedGameData} from "../../server/data/MonkeysGoldParsedGameData";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {IReelStoppedData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";

export class MonkeysGoldBigSymbolLandController extends ReelStopPresentationController {

    private _bigSymbolLandView:MonkeysGoldBigSymbolLandView;
    private _mode:string;
    private _nextMode:string;

    constructor(index:number) {
        super(index, "MonkeysGoldBigSymbolLandController");
        this._bigSymbolLandView = MonkeysGoldGameModuleConfig.monkeysGoldBigSymbolLandView = new MonkeysGoldBigSymbolLandView();
    }

    protected parseFeatureGameData(data:MonkeysGoldParsedGameData):void {
    }

    private onAllSymbolsOut(reelId:number):void {
    }

    public onReelSpinStopped(data:IReelStoppedData):void {
        this.dispatchCompleteEvent(data.reelId);
    }

    public abort():void {
    }

}